import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { SharedService } from '../../../shared/services/share.services';
import { FormControl, Validators } from '@angular/forms';
import { DialogService } from '../../../shared/services/dialog.service';
import { Utility } from '../../../common/utility';
import { AppMessages } from '../../../shared/constants/messages';
import { AppConstants } from '../../../shared/constants/constants';
import { CentreListModel } from '../../../models/centre/centre.model';
import { CentrePopupComponent } from './centre-popup.component';
import { ManageCentreService } from './manage-centre.service';
import { TMBDataTableComponent } from '../../../components/data-table/data-table.component';

@Component({
  selector: 'manage-centre-list',
  templateUrl: './manage-centre-list.component.html',
  providers: [ManageCentreService]
})

export class ManageCentreComponent extends TMBDataTableComponent implements OnInit {
  public dataRow = new Array<CentreListModel>();
  public filterData = { countryId: null };
  public countryData: any[];

  constructor(private manageCentreService: ManageCentreService,
    public utility: Utility,
    public dialogService: DialogService,
    public sharedService: SharedService) {
      super(sharedService);
  }

  ngOnInit() {
    this.getCountryData();
    this.setPage({ offset: 0 });
  }

  getCountryData() {
    this.manageCentreService.getCountryHasCentre().subscribe(
      (result) => {
        if (result) {
          this.countryData = result.json();
        }
      }
    );
  }

  /**
   * Populate the table with new data based on the page number
   * @param page The page to select
   */
  setPage(pageInfo) {
    this.page.pageNumber = pageInfo.offset;

    const param = {
      pageSize: this.page.size,
      currentPage: this.page.pageNumber + 1,
      countryId: this.filterData.countryId === 'null' ? '' : this.filterData.countryId
    };
    this.manageCentreService.getCentreList(param).subscribe(
      (result) => {
        if (result) {
          const data = result.json();
          // update page info
          this.page.totalElements = data['totalRecords'];
          this.page.totalPages = Math.ceil(this.page.totalElements / this.page.size);
          // update dataSource
          this.dataRow = data['list'];
        }
      }
    );

  }


  /**
   * Return centre name separated by comma
   * @param string userId
   */
  getDataTitle(dataArr: any[]) {
    let dataTitle = '';
    const seperate = ', ';
    for (let i = 0; i < dataArr.length; i++) {
      dataTitle += ((i != 0) ? seperate : '') + dataArr[i];
    }
    return dataTitle;
  }

  /**
   * Filter list by countryId
   */
  onCountryChange() {
    this.setPage({ offset: 0 });
  }

  onAddNewCentre() {
    this.dialogService.openComponentDialog(CentrePopupComponent, {}, { 'width': '900px' }).subscribe(result => {
      // if add user success then reload the list
      if (result) {
        this.getCountryData();
        this.reloadPage(this.page.pageNumber, this.dataRow);
      }

    });
  }

  onEditCentre(centreId: string) {
    const data = {
      id: centreId,
    };
    this.dialogService.openComponentDialog(CentrePopupComponent, data, { 'width': '900px' }).subscribe(result => {
      if (result) {
        this.updateCountryData();
        // dispatch change centre info event to header component
        if (result.hasOwnProperty('centreName')) {
          this.sharedService.announceCentreInfoUpdate(result['centreName']);
        }
      }
    });
  }

  updateCountryData() {
    this.manageCentreService.getCountryHasCentre().subscribe(
      (result) => {
        if (result) {
          this.countryData = result.json();
          if (this.countryData.filter(c => c.id === this.filterData.countryId).length === 0) {
            this.filterData.countryId = 'null';
          }

          // Reload page when country loaded
          this.reloadPage(this.page.pageNumber, this.dataRow);
        }
      }
    );
  }

}






// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/centre/manage-centre/manage-centre-list.component.ts